import { lazy } from "react";
import { RouteConfig } from "../../../../types/RouteConfig";

export const defaultFoodSafetyDocumentRoute: RouteConfig<'with-page'> = {
    name: 'Food Safety',
    path: '/default-documents/food-safety',
    context: 'member',
    page: lazy(() => import('.')),
    roles: ['ncassAdmin'],
}